<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: trash bin</title>
  <g fill-rule="evenodd">
    <path
      d="M17.7801233,21.3097233 L11.8352569,21.3097233 L5.89039051,21.3097233 L5.50244427,5.10158419 L6.91762846,5.10158419 L16.7547067,5.10158419 L18.1680696,5.10158419 L17.7801233,21.3097233 Z M7.8283004,3.27841897 L15.8422134,3.27841897 L15.8422134,1.82134387 L7.8283004,1.82134387 L7.8283004,3.27841897 Z M16.7547067,-1.77635684e-15 L6.91762846,-1.77635684e-15 C6.41493755,-1.77635684e-15 6.00695652,0.407981028 6.00695652,0.910671937 L6.00695652,3.28024032 L2,3.28024032 L2,5.10158419 L3.6647083,5.10158419 L4.19471937,22.3424253 C4.25482372,22.7959399 4.64094862,23.1310672 5.09628458,23.1310672 L11.8352569,23.1310672 L18.5760506,23.1310672 C19.0313866,23.1310672 19.4138688,22.7941186 19.4794372,22.3424253 L20.0094482,5.10158419 L21.6723352,5.10158419 L21.6723352,3.28024032 L17.6653787,3.28024032 L17.6653787,0.910671937 C17.6653787,0.407981028 17.2573976,-1.77635684e-15 16.7547067,-1.77635684e-15 L16.7547067,-1.77635684e-15 Z"
    />
    <polygon
      points="7.8288468 19.1721942 9.65019067 19.1721942 9.65019067 7.01290245 7.8288468 7.01290245"
    />
    <polygon
      points="14.021416 19.1721942 15.8427598 19.1721942 15.8427598 7.01290245 14.021416 7.01290245"
    />
    <polygon
      points="10.9251314 19.1721942 12.7464753 19.1721942 12.7464753 7.01290245 10.9251314 7.01290245"
    />
  </g>
</Icon>
